import EdgeType from '../enums/edgeType';

const EDGE_INDEXES = {
	[EdgeType.HOUSE_FREESTANDING]: 9,
	[EdgeType.HOUSE_ATTACHED]: 8,
	[EdgeType.BLOCK_ATTACHED]: 7,
	[EdgeType.LANDING_ATTACHED]: 10,
	[EdgeType.STAIR_ATTACHED]: 10,
	[EdgeType.LANDING]: 10,
	[EdgeType.STAIR]: 10,
	[EdgeType.HOUSE]: 5,
	[EdgeType.GROUND]: 4,
	[EdgeType.DECKING]: 3,
	[EdgeType.RAILING]: 2,
	[EdgeType.NO_RAILING]: 1,
};

export default EDGE_INDEXES;
